import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import { useNavigate, useParams } from 'react-router-dom';
import { PaymentSuccess, PaymentFailure } from './PaymentMessage';

const WalletRechargeInitiated = ({ paymentDetails }) => {
    const authState = useSelector(state => state.authReducer);
    const [fetchData, { loading }] = useFetch();
    const navigate = useNavigate();
    const [isDataSaved, setIsDataSaved] = useState(false);
    const [viewButtonsEnabled, setViewButtonsEnabled] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [viewHistoryEnabled, setViewHistoryEnabled] = useState(false);
    const [viewInvoiceEnabled, setViewInvoiceEnabled] = useState(false);
    const [okButtonDisabled, setOkButtonDisabled] = useState(false);

    const paymentStatus = Math.round(Math.random());
    const [transactionID, setTransactionID] = useState('');

   // Generate a random transaction ID (for demonstration purposes)
   const generateTransactionID = () => {
        return Math.random().toString(36).substring(2, 11);
    };

    const handleOKButtonClick = async () => {
        try {
            const config = {
                url: "/api/payments",
                method: "post",
                data: { paymentDetails, transactionID, paymentStatus },
                headers: { Authorization: authState.token }
            };

            const response = await fetchData(config);
            if (response.ok) {
                setResponseMessage('Data saved successfully');
                setViewHistoryEnabled(true);
                setViewInvoiceEnabled(true);
                setOkButtonDisabled(true);
            } else {
                setResponseMessage('Failed to save data');
            }
        } catch (error) {
            console.error('Error saving data:', error);
            setResponseMessage('Error saving data');
        }
    };

    useEffect(() => {
        setTransactionID(generateTransactionID());
    }, []);

    const handleViewInvoiceClick = () => {
        navigate('/invoice');
    };

    const handlePaymentHistoryClick = () => {
        navigate('/paymentlog');
    };

    return (
        <div className="payment-initiated">
            <p className='text-blue-800 text-2xl'>Payment Initiated for the order - </p>
            <div>
                <p>Name: {paymentDetails.customerName}</p>
                <p>Amount: {paymentDetails.amount}</p>
                <p>Payment Gateway: {paymentDetails.paymentGateway}</p>
                <p>Payment Mode: {paymentDetails.paymentMode}</p>
            </div>
            {paymentStatus === 1 ? <PaymentSuccess /> : <PaymentFailure />}
            <p style={{ color: paymentStatus === 1 ? 'green' : 'red' }}>Transaction ID: {transactionID}</p>
            <p style={{ color: responseMessage.includes('success') ? 'green' : 'red' }}>{responseMessage}</p>
            <div className="buttons">
                <button onClick={handleOKButtonClick} disabled={okButtonDisabled || paymentStatus !== 1 || loading}>
                    {loading ? 'Saving data...' : 'OK'}
                </button>
                <button onClick={handlePaymentHistoryClick} disabled={!viewHistoryEnabled}>View Payment History</button>
                <button onClick={handleViewInvoiceClick} disabled={!viewInvoiceEnabled}>View Invoice</button>
            </div>
            {/* {paymentStatus === 1 ? <p>Transaction ID: {generateTransactionID()}</p> : null} */}
        </div>
    );
};

export default WalletRechargeInitiated;
